var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vfm-modal-header"},[_c('span',[_vm._t("default")],2),_c('button',{on:{"click":_vm.close}},[_c('i',{staticClass:"material-icons notranslate"},[_vm._v("close")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }